import { render } from "./PaymentSuccessView.vue?vue&type=template&id=60bf58bf"
import script from "./PaymentSuccessView.vue?vue&type=script&lang=js"
export * from "./PaymentSuccessView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__